<script setup lang="ts">
import { BookOpen, FolderOpen } from '@lucide/vue'
import { Button, InlineAlert } from 'catalyst-vue'
import { useLibraryStore } from '../../stores/library'
import { useControlSize } from '../../lib/library-layout'

/**
 * 未授權來源清單。授權綁在個別 handle 上，且 requestPermission 必須位於
 * 使用者手勢的呼叫堆疊內，因此每個來源各有自己的按鈕，一次手勢只處理一個。
 *
 * 這是次要說明，不遮蔽作品網格：書庫本身在沒有權限時也看得到全部作品。
 * 用 InlineAlert 而非 StateCard：StateCard 只有 icon slot，沒有 default slot，
 * 放不進每個來源各自的按鈕列。
 */
const store = useLibraryStore()
const controlSize = useControlSize()
</script>

<template>
  <InlineAlert v-if="store.unauthorizedSources.length" tone="warning" class="sources-panel">
    <p class="sources-panel-title">需要資料夾權限</p>
    <p class="sources-panel-message">這些來源目前沒有讀取權限，底下的作品可以瀏覽但還不能開啟。開啟時若選擇「每次造訪時允許」，之後重新載入就不必再按。</p>
    <ul class="sources-list">
      <li v-for="source in store.unauthorizedSources" :key="source.id">
        <component :is="source.kind === 'comic' ? BookOpen : FolderOpen" :size="16" aria-hidden="true" />
        <span>{{ source.name }}</span>
        <small>{{ source.kind === 'comic' ? '單一作品資料夾' : '根資料夾' }}</small>
        <Button color="primary" :size="controlSize" :disabled="store.busy" @click="store.authorize(source.id)">開啟</Button>
      </li>
    </ul>
  </InlineAlert>
</template>
